/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgEditAnalytics = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M2 4h20v8.76l-1.88-1.881a3.018 3.018 0 0 0-.12-.113V6H4v11h5.998v2H2zm13.5 5.296v1.96l-.041.04h-2.343l-.575.454-1.52 1.29-2.473-2.825-.834 1.081H5v-2h1.73l1.722-2.23 2.777 3.175.045-.039 1.148-.906zm3.205 2.997a1 1 0 0 0-1.414 0l-5.293 5.293V22h4.414l5.293-5.293a1 1 0 0 0 0-1.414zM13.998 20v-1.586l4-4L19.584 16l-4 4z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgEditAnalytics as EditAnalytics };
